import { Chip, FormControl, FormHelperText, Grid, IconButton, Input, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import AddIcon from '@mui/icons-material/Add';
export default function AddVariablesForSendMessage({ formik, state, IsSmsCredentialsUsed }) {
    const [currValue, setCurrValue] = useState("");
    const handleChange = (event) => {
        const { value, name } = event.target;
        setCurrValue(event.target.value);
    };

    const addVariables = () => {
        if (formik?.values?.sendMessageVariables.includes(currValue)) {
            formik.setFieldError("sendMessageVariables", `Variable already exist.`);
            return;
        }
        formik.setFieldValue("sendMessageVariables", [...formik?.values?.sendMessageVariables, currValue]);
        setCurrValue("")
    }


    const handleDelete = (item, index) => {
        let arr = [...formik.values.sendMessageVariables]
        arr.splice(index, 1)
        formik.setFieldValue("sendMessageVariables", arr);

    }
    return (
        <Grid container display={"flex"} width={"100%"}>

            <Grid item padding={2} md={6}>

                {/* <Typography className='text-muted mb-2'>Sender ID should be 6 alpha characters or numeric.</Typography> */}

                <div >
                    {formik?.values?.sendMessageVariables?.map((item, index) => (
                        <Chip size="small" onDelete={() => { handleDelete(item, index) }} label={item} sx={{ margin: "4px" }} />
                    ))}
                </div>
                <FormControl error={formik.errors?.sendMessageVariables}  >
                    <Grid>

                        <Input
                            value={currValue}
                            onChange={handleChange}
                        // onKeyDown={handleKeyUp}
                        />

                        <IconButton onClick={addVariables} disabled={!currValue}>
                            <AddIcon />
                        </IconButton>
                    </Grid>
                    <FormHelperText>{
                        formik.errors?.sendMessageVariables}</FormHelperText>

                </FormControl>

            </Grid>
        </Grid>
    );
}
